import 'isomorphic-fetch';

export const WIDGET_FETCH = 'WIDGET_FETCH';
export const WIDGET_SUCCESS = 'WIDGET_SUCCESS';
export const WIDGET_FAILURE = 'WIDGET_FAILURE';
export const WIDGET_RESET_ALL = 'WIDGET_RESET_ALL';
export const WIDGET_DELETE = 'WIDGET_DELETE';
export const WIDGET_REFRESH = 'WIDGET_REFRESH';

import { trackGAEvent } from 'Actions/adsActions';
import { setGlobalNotification, getFetchConfig } from 'Actions/GlobalMetaActions';
import { getCacheBuster } from 'Actions/MetaActions';
import { mapLoadingBehaviour, getPageSize } from 'Actions/UserSettingsActions';
import { responseNormalizer, updateUstate } from 'Actions/responseNormalizer';

export const requestWidget = ( name ) => {
	return {
		type: WIDGET_FETCH,
		name
	};
};

export const receiveWidget = ( name, data ) => {
	return {
		type: WIDGET_SUCCESS,
		name,
		data
	};
};

export const failedWidget = ( name, error ) => {
	return {
		type: WIDGET_FAILURE,
		name,
		error
	};
};

export const resetWidgets = () => {
	return {
		type: WIDGET_RESET_ALL
	};
};

export const deleteWidget = ( name ) => {
	return {
		type: WIDGET_DELETE,
		name
	};
};

export const refreshWidget = ( name = '' ) => {
	return {
		type: WIDGET_REFRESH,
		name
	};
};


/* Request Functions */
export function fetchWidget( request, widgetName, type, cacheBust = false ) {
	return function( dispatch, getState ) {
		// start Fetch
		dispatch( requestWidget( widgetName ) );

		const state = getState(),
			forumSiteUrl = state.topifyPresets.forumSite.url;

		const userID = state.ustate.id ? state.ustate.id : 0,
			fetchConfig = dispatch( getFetchConfig( true ) ),
			cacheBustQueryString = '&_=' + ( cacheBust ? cacheBust : ( getCacheBuster( getState ) || 0 ) ),
			lb = mapLoadingBehaviour( state.ui.userSettings.loadingBehavior ),
			page_size = request.pageSize ? request.pageSize : dispatch( getPageSize() );

		let id = '',
			url = forumSiteUrl;

		switch( type ) {
			case 'activeTopics':
			case 'popularTopics':
				let sort = type === 'popularTopics' ? `&sortby=views&sortorder=desc` : '';
				url += `?v=3.0&ajax=1&uid=${ userID }&req=search&id=new${ sort }&pagesize=${ page_size }&page=${ request.page }&lb=${ lb }${ cacheBustQueryString }`;
				break;

			default:
				// save data to State
				setTimeout( () => { dispatch( receiveWidget( widgetName, {} ) ) }, 300 );
				return true;
		}

		return fetch( url, fetchConfig ).then( ( response ) => {
			if( !response.ok ) {
				try {
					response.json().then( ( json ) => {
						setGlobalNotification( dispatch, json, response );
					} ).catch( () => {
						setGlobalNotification( dispatch, {}, response );
					} );
				} catch( e ) {
					setGlobalNotification( dispatch, {}, response );
				}
				dispatch( failedWidget( widgetName, 'Bad response from server' ) );

			} else {
				response.json().then( ( json ) => {
					setGlobalNotification( dispatch, json, { ok: true } );

					// Record the Google Analytics event
					dispatch( trackGAEvent( false, 'widget_' + type, 'userAction', 'consumption' ) );

					let responseData = json.search && json.search.data.length > 0 ? json.search.data[ 0 ] : false,
						other = {
							page: request.page,
							itemId: ( responseData ? parseInt( responseData.id ) : 0 ),
							otherParams: {
								searchQuery: ( responseData ? responseData.query || request.searchQuery : null ),
								showposts: ( responseData && responseData.showposts ? responseData.showposts : 0 ),
								forumId: ( responseData && responseData.searchForum || null ),
								action: ( responseData && responseData.action || null ),
								showtopics: request.showtopics || null
							}
						};

					let result = responseNormalizer( json, request.page, other );

					dispatch( updateUstate( json, result ) );

					// save data to State
					dispatch( receiveWidget( widgetName, result ) );
				} );
			}
		} ).catch( ( error ) => {
			setGlobalNotification( dispatch, {}, error );
			dispatch( failedWidget( widgetName, 'Bad response from server' ) );
		} );
	}
}


// WEBPACK FOOTER //
// ./src/actions/WidgetActions.js